module.exports = __webpack_public_path__ + "static/media/SS.7d0c392d.jpg";